/*
 * @Author: 张怀宇
 * @Date: 2020-01-17 13:20:51
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-05-30 10:32:35
 */

import Vue from 'vue'
import axios, { AxiosInstance } from 'axios'
import { Message } from 'element-ui'
import router from '../../router'

let options = {
  // timeout: 60000,
  timeout:300000,
  params: {
    t: new Date().getTime()
  },
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'access-control-allow-origin': '*'
  }
}
const axiosInstance = axios.create(options)
axiosInstance.defaults.headers.common['Authorization'] = localStorage.getItem(
  'token'
)
//axios请求拦截
axiosInstance.interceptors.request.use(
  (config: any) => {
    if (config.url.indexOf('login') > -1) {
      localStorage.setItem('token', '')
      config.headers.Authorization = ''
    } else {
      config.headers.Authorization = localStorage.getItem('token')
      console.log(config.headers.Authorization,'config.headers.Authorization')
    }
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.headers.token) {
      localStorage.setItem('token', response.headers.token)
    }
    if (response.status !== 200 || response.data.code < 0) {
      Message({
        type: 'error',
        message: response.data.msg
      })
      return Promise.reject(response)
    }
    return Promise.resolve(response)
  },
  function(error) {
    if (error.response.status == 600) {
      localStorage.setItem('token', '')
      Message({
        type: 'error',
        message: error.response.data.msg
      })
      router.push('/login')
    } else if (error.request.status == 502) {
      Message({
        type: 'error',
        message: '服务器繁忙'
      })
    } else {
      Message({
        type: 'error',
        message: error.response.data.msg
      })
    }
    return Promise.reject(error.response)
  }
)

declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosInstance
  }
}

export default axiosInstance
